import NpawPluginAdapters from "npaw-plugin-adapters";
import { NPAW_CUSTOM_CONSTANTS } from "./npawConstants";

export default class pwaAdapter extends NpawPluginAdapters.video.Videojs {

    getPlayerName() {
        return NPAW_CUSTOM_CONSTANTS.PLAYER_NAME;
    }
}